<template>
  <div>
    <publicHead />
    <quotedPrice />
  </div>
</template>

<script>
import quotedPrice from './components/quotedPrice/index.vue'
import publicHead from './components/publicHead/index.vue'

export default {
    components: {
        publicHead,
        quotedPrice
    },
    mounted() {
      // 删除订单管理 保单管理按钮
      const right_nav = document.getElementsByClassName('right_nav')
      right_nav[0] && right_nav[0].remove()
    }
}
</script>

<style>

</style>